var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.2284,
    cy: 12.768,
    r: 12.1972,
    fill: "#5A4A99"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2934 18.3367H14.8694C16.487 18.3367 17.2964 18.3367 17.7987 17.8566C18.3015 17.3754 18.3015 16.6029 18.3015 15.056V14.5093C18.3015 12.963 18.3015 12.1899 17.7987 11.7093C17.3594 11.2893 16.6855 11.2363 15.4414 11.2297M9.72136 11.2297C8.47725 11.2363 7.80342 11.2893 7.36412 11.7093C6.86133 12.1899 6.86133 12.963 6.86133 14.5093V15.056C6.86133 16.6029 6.86133 17.376 7.36412 17.8566C7.53572 18.0206 7.74279 18.1283 8.00534 18.1994",
    stroke: "white",
    strokeWidth: 1.17093,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5822 7.40112V14.5091M12.5822 14.5091L10.8662 12.5954M12.5822 14.5091L14.2982 12.5954",
    stroke: "white",
    strokeWidth: 1.17093,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.7d3cb5e88aefec6d6af05916de16245d.svg";
export { ForwardRef as ReactComponent };